module.exports = __webpack_public_path__ + "img/vehicleBusWhite.a09849ce.svg";